import { Injectable, signal, WritableSignal } from '@angular/core';
import { FloatingDirective } from "@core/directives/floating/floating.directive";

@Injectable({ providedIn: 'root' })
export class FloatingRegistryService {
  private readonly _activeFloating: WritableSignal<FloatingDirective | null> = signal<FloatingDirective | null>(null);

  register (directive: FloatingDirective): void {
    const current: FloatingDirective | null = this._activeFloating();

    if (current && current !== directive) current.closeHost();

    this._activeFloating.set(directive);
  }

  unregister (directive: FloatingDirective): void {
    if (this._activeFloating() === directive)
      this._activeFloating.set(null);
  }
}
